import React, { Component } from 'react';
import { Form, Input, Icon, Button, message } from 'antd';
import { wrapStyle } from './style';
import { hasErrors } from '../../common/utils';
import { changePassword } from '../../common/fetch';

class ResetPassword extends Component {
	handleSubmit = async (e) => {
		const { getFieldValue } = this.props.form;
		e.preventDefault();
		const body = {
			old_password: getFieldValue('curPw'),
			new_password: getFieldValue('newPw')
		};
		try {
			await changePassword(body);
			message.success('Success to change password');
		} catch (error) {
			message.error('Failed to Change Password');
		}
	};
	render() {
		const {
			getFieldDecorator,
			getFieldValue,
			getFieldsError,
			getFieldError,
			isFieldTouched
		} = this.props.form;
		const curPwError = isFieldTouched('curPw') && getFieldError('curPw');
		const newPwError = isFieldTouched('newPw') && getFieldError('newPw');
		const chkPwError = isFieldTouched('chkPw') && getFieldError('chkPw');
		return (
			<Form style={wrapStyle} onSubmit={this.handleSubmit}>
				<Form.Item validateStatus={curPwError ? 'error' : ''}>
					{getFieldDecorator('curPw', {
						rules: [
							{
								required: true,
								message: 'Please input your Current Password!'
							}
						]
					})(
						<Input
							prefix={
								<Icon
									type="lock"
									style={{ color: '#A8A8B1' }}
								/>
							}
							type="password"
							placeholder="Current Password"
						/>
					)}
				</Form.Item>
				<Form.Item validateStatus={newPwError ? 'error' : ''}>
					{getFieldDecorator('newPw', {
						rules: [
							{
								required: true,
								message: 'Invalid password. It has to contain at least 8 characters, at least one digit and one character.',
								pattern: /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/,
							},
						]
					})(
						<Input
							prefix={
								<Icon
									type="lock"
									style={{ color: '#A8A8B1' }}
								/>
							}
							type="password"
							placeholder="New Password"
						/>
					)}
				</Form.Item>
				<Form.Item validateStatus={chkPwError ? 'error' : ''}>
					{getFieldDecorator('chkPw', {
						rules: [
							{
								required: true,
								message: 'Please check your new Password!'
							},
							{
								validator(_, value) {
									if (!value || getFieldValue('newPw') === value) {
										return Promise.resolve();
									}
									return Promise.reject(new Error('passwords do not match'));
								}
							},
						]
					})(
						<Input
							prefix={
								<Icon
									type="lock"
									style={{ color: '#A8A8B1' }}
								/>
							}
							type="password"
							placeholder="Check Password"
						/>
					)}
				</Form.Item>
				<Form.Item>
					<Button
						type="primary"
						htmlType="submit"
						disabled={hasErrors(getFieldsError())}
					>
						Reset Password
					</Button>
				</Form.Item>
			</Form>
		);
	}
}

const WrappedResetPassword = Form.create({ name: 'reset form' })(ResetPassword);

export default WrappedResetPassword;
